import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { destinationsApi } from '../../api/lib/destinations';
import { destinationsKeys } from '../../api/query-keys/destinations';
import { CreateDestinationPayload } from '../../api/types/payload/create-destination.payload';

import { ApiError } from '@/types/interfaces/api-error';

export const useCreateDestination = (onSuccess?: () => void) => {
  const { t } = useTranslation(['createDestination']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateDestinationPayload) => destinationsApi.createDestination(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: destinationsKeys.all,
      });
      onSuccess?.();
      toast.success(t('createDestination:popup.destination'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
